import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { searchTextState } from '../../redux/employee_pay_scales'

class SearchField extends Component {

  handleOnKeyUp = () => {
    this.props.search(this.refs.searchInput.value)
    this.props.dispatch(searchTextState(this.refs.searchInput.value))
    this.props.callback()
  }

  componentDidMount() {
    if (this.props.employee_pay_scales && this.props.employee_pay_scales.previousSearchText) {
      this.setValue(this.props.employee_pay_scales.previousSearchText)
    } else {
      this.setValue("")
    }
  }

  setValue(value) {
    ReactDOM.findDOMNode(this.refs.searchInput).value = value
    this.props.search(value)
  }

  render() {
    return (
      <input
        ref='searchInput'
        className='form-control'
        type='text'
        defaultValue={this.props.defaultValue}
        placeholder="Search Employees..."
        onKeyUp={this.handleOnKeyUp} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    employee_pay_scales: state.employee_pay_scales
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(SearchField)


// WEBPACK FOOTER //
// ./src/modules/Employee Pay Scales/Components/TableCustomComponents/SearchField.js